import Highway from '@dogstudio/highway';
import { mq } from '../util/matchMedia';
import { WipeUp } from './WipeUp';
import { WipeDown } from './WipeDown';
import { getAllPages, getIndexBySlug } from '../util/helpers';


export default class Page extends Highway.Transition {

  in({ from, to, done }) {
    const fromIndex = getIndexBySlug(from.dataset.routerView);
    const toIndex = getIndexBySlug(to.dataset.routerView);
    const isLastPage = getAllPages().length - 1;

    // Transition in one direction for all pages at mobile
    if (mq.isMobile) {
      WipeDown(from, to, done);

      // Handle last page to first looping
    } else if (fromIndex === isLastPage && toIndex === 0) {
      WipeDown(from, to, done);

      // Determine direction of transition based on page order
    } else {
      toIndex > fromIndex
        ? WipeDown(from, to, done)
        : WipeUp(from, to, done);
    }
  }

  out({ done }) {
    done();
  }
}